import { RootState } from "store";

export const getIsUnderwritingCoverageAdjustmentAvailable = (state: RootState) =>
  state.account.underwritingAvailability.coverageAdjustmentAvailable;
